import type { ToastIntent } from '@fluentui/react-components';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useRuntime } from '@/app/providers/runtime-provider';
import { useNotify } from '@/shared/hooks/use-notify';

const INTENT: Record<'replayed' | 'failed', ToastIntent> = {
  replayed: 'success',
  failed: 'error',
};

/**
 * Back from a step-up: replays, once, the action that was refused with STEP_UP_REQUIRED (same
 * idempotency key, same If-Match), then announces the outcome in a toast. A failed step-up lands
 * on /signed-out, which discards the saved action.
 */
export function PendingActionReplay() {
  const { t } = useTranslation('backoffice');
  const { replayPendingAction } = useRuntime();
  const notify = useNotify();
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    void replayPendingAction(false).then((outcome) => {
      if (outcome === 'replayed' || outcome === 'failed')
        notify({ intent: INTENT[outcome], message: t(`pendingAction.${outcome}`) });
    });
  }, [replayPendingAction, notify, t]);

  return null;
}
